import React from "react";
import CloseIcon from '@material-ui/icons/Close';
import styles from "../../../hygienist/ProfilePage/components/components.module.scss";

interface LeftHandedModalProps {
    onCloseButtonClick: (e: any) => void;
}

const LeftHandedModal = ({ onCloseButtonClick }: LeftHandedModalProps) => {
    return (
        <div className={styles.wizardModalOverlay} onClick={onCloseButtonClick}>
            <div className={styles.wizardModalContainer} onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className={styles.wizardModalHeader}>
                    <div className={styles.wizardHeaderContent}>
                        <h1 className={styles.wizardModalTitle}>Are you left-handed?</h1>
                    </div>
                    <button className={styles.wizardCloseButton} onClick={onCloseButtonClick} aria-label="Close modal">
                        <CloseIcon />
                    </button>
                </div>

                {/* Body */}
                <div className={styles.wizardModalBody}>
                    <div className={styles.wizardInfoBox}>
                        <p>Some dental offices have their operatories set up in a way that makes it very difficult for left-handed clinicians to work.</p>
                        <p>Let us know if you are left-handed and we'll help you avoid a really awkward day.</p>
                    </div>
                </div>

                {/* Footer */}
                <div className={styles.wizardModalFooter}>
                    <button
                        className={styles.wizardSaveButton}
                        onClick={onCloseButtonClick}
                        style={{ flex: 'none', minWidth: '120px' }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LeftHandedModal;
